require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-e-commerce-website-specification-template.json") })
        }
      }, "path---blog-e-commerce-website-specification-template");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-e-commerce-website-specification-template!./.cache/json/blog-e-commerce-website-specification-template.json
// module id = 437
// module chunks = 231608221292675